import {
    useToast as usePrimeToast
} from 'primevue/usetoast'

export function useToast() {
    const toast = usePrimeToast()

    // Supports both:
    //   toast.success('Message')
    //   toast.success('Titre', 'Message')  ← legacy 2-arg pattern
    function resolve(summaryOrMsg, detailOrDuration, defaultSummary, defaultLife) {
        if (typeof detailOrDuration === 'string') {
            // 2-arg: (title, message)
            return {
                summary: summaryOrMsg,
                detail: detailOrDuration,
                life: defaultLife
            }
        }
        // 1-arg: (message) or (message, duration)
        return {
            summary: defaultSummary,
            detail: summaryOrMsg,
            life: typeof detailOrDuration === 'number' ? detailOrDuration : defaultLife
        }
    }

    const success = function(summaryOrMsg, detailOrDuration) {
        const r = resolve(summaryOrMsg, detailOrDuration, 'Succès', 3000)
        toast.add({
            severity: 'success',
            ...r
        })
    }

    const error = function(summaryOrMsg, detailOrDuration) {
        const r = resolve(summaryOrMsg, detailOrDuration, 'Erreur', 7000)
        toast.add({
            severity: 'error',
            ...r
        })
    }

    const warn = function(summaryOrMsg, detailOrDuration) {
        const r = resolve(summaryOrMsg, detailOrDuration, 'Avertissement', 5000)
        toast.add({
            severity: 'warn',
            ...r
        })
    }

    const info = function(summaryOrMsg, detailOrDuration) {
        const r = resolve(summaryOrMsg, detailOrDuration, 'Information', 3000)
        toast.add({
            severity: 'info',
            ...r
        })
    }

    return {
        success,
        error,
        warn,
        info
    }
}